import React, { Component } from 'react'
import L from 'leaflet'
import { CircleMarker, Popup, Polyline, Tooltip } from 'react-leaflet'
import RotatedMarker from './rotatedMarker'
import NaviIcon from './navi-arrow.svg'
import WindIcon from './wind-2x.png'


const playerIcon = new L.Icon({
  iconUrl: NaviIcon,
  iconSize: new L.Point(17, 17),
});

const subPlayerIcon = new L.Icon({
  iconUrl: NaviIcon,
  iconSize: new L.Point(15, 15),
});


const windIcon = new L.Icon({
  iconUrl: WindIcon,
  iconSize: new L.Point(20, 20),
});

const mainColor = '#ff5100';
const subColor = '#a9ceec';


export default class MainPlayer extends Component {

  render() {
    const { device, isSailing } = this.props;
    const CircleM = <CircleMarker center={device.pos} radius={18} />

    // Max Speed Marker
    const MaxSpeedM = device.maxSpeedPoint ? (
      <CircleMarker center={device.maxSpeedPoint.pos} radius={0} opacity={0} fillOpacity={0}>
        <Tooltip permanent direction="top" offset={[0, 0]} opacity={1} className="no-background-tooltip">
          <span style={{ color: 'red', fontWeight: 'bold', fontSize: '12px', textShadow: '1px 1px 0px white' }}>
            Max: {device.maxSpeedPoint.speed.toFixed(2)}
          </span>
        </Tooltip>
      </CircleMarker>
    ) : null;

    const GpsPop = (
      <Popup direction={'top'} offset={[0, -20]} >
        <table>
          <tbody>
            <tr>
              <th>User</th><td>{device.name}</td>
            </tr>
            <tr>
              <th>SPEED</th><td>{device.spd} {this.props.authUser.unit}</td>
            </tr>
            <tr>
              <th>VMG</th><td>{device.vmg} {this.props.authUser.unit}</td>
            </tr>
            <tr>
              <th>ANGLE</th><td>{device.ang} deg</td>
            </tr>
          </tbody>
        </table>
      </Popup>);

    const WindPop = (
      <Popup direction={'top'} offset={[0, -20]} >
        <table>
          <tbody>
            <tr>
              <th>Device</th><td>{device.id}</td>
            </tr>
            <tr>
              <th>SPEED</th><td>{device.spd} {this.props.authUser.unit}</td>
            </tr>
            <tr>
              <th>WIND</th><td>{device.windspd} {this.props.authUser.wind_unit}</td>
            </tr>
            <tr>
              <th>WIND</th><td>{device.winddir} deg</td>
            </tr>
          </tbody>
        </table>
      </Popup>);

    var color;
    device.main ? color = mainColor : color = subColor

    var icon;
    device.main ? icon = playerIcon : icon = subPlayerIcon

    return (
      <span>
        <RotatedMarker
          // if position changes, marker will drift its way to new position
          //position={ deviceMap[deviceId].pos }
          position={device.pos}
          // time in ms that marker will take to reach its destination
          //duration={1000}
          icon={device.wind ? windIcon : icon}
          rotationAngle={device.rotate}
          rotationOrigin={'center'}
        >
          {device.wind ? WindPop : GpsPop}
        </RotatedMarker>
        {device.main && CircleM}
        {device.main && MaxSpeedM}



        {renderGhostTrack(device.all_lines, device.lines)}

        {renderTrackLines(device.coloredLines, this.props.colorMode, device.sessionMaxSpeed || (device.maxSpeedPoint ? device.maxSpeedPoint.speed : 10), this.props.selectionRange)}
        {renderDistanceMarkers(device.coloredLines, this.props.authUser.unit, this.props.authUser.map_speed_interval, this.props.authUser.map_distance_display)}
      </span>
    );
  }

}

function renderGhostTrack(allLines, currentLines) {
  if (!allLines || allLines.length === 0) return null;

  // Show ghost track only if current selection is a subset (e.g. specific Leg)
  // If currentLines covers the full track, we don't need a ghost track background.
  if (currentLines && currentLines.length >= allLines.length) return null;

  return (
    <Polyline
      positions={allLines}
      color="grey"
      weight={3}
      opacity={0.4}
    />
  );
}

function renderTrackLines(lines, colorMode, maxSpeed, selectionRange) {
  if (!lines || lines.length === 0) return null;

  // 区間選択中かどうかを判定（selectionRangeが全体でない場合）
  const hasSelection = selectionRange && (selectionRange.min > 0 || selectionRange.max < lines.length - 1);

  const segments = [];


  if (colorMode === 'speed') {
    // Pseudo Color Mode
    for (let i = 0; i < lines.length - 1; i++) {
      const pt1 = lines[i];
      const pt2 = lines[i + 1];

      const pos1 = pt1.pos || pt1;
      const pos2 = pt2.pos || pt2;

      // 区間選択中かつ非選択区間の場合はグレー表示
      const isOutOfSelection = hasSelection && (i < selectionRange.min || i >= selectionRange.max);

      if (isOutOfSelection) {
        segments.push(
          <Polyline
            key={i}
            positions={[pos1, pos2]}
            color={'#999'}
            weight={3}
            opacity={0.3}
          />
        );
      } else {
        // Use average speed of segment
        const speed = (pt1.speed + pt2.speed) / 2;
        // Map 0 -> 0.9*maxSpeed to Hue 240 -> 0.
        // Speeds >= 0.9*maxSpeed are Red (0).
        let ratio = speed / (maxSpeed || 1);
        if (ratio > 0.9) ratio = 0.9;

        const hue = (1 - (ratio / 0.9)) * 240;
        const color = `hsl(${hue}, 100%, 50%)`;

        segments.push(
          <Polyline
            key={i}
            positions={[pos1, pos2]}
            color={color}
            weight={4}
            opacity={1.0}
          />
        );
      }
    }
    return segments;

  } else {
    // Default S/P Mode
    // 区間選択中の場合、セグメントごとにカラー/グレー判定
    let currentSegment = [];
    let currentSegmentIsStb = null;
    let currentSegmentIsGray = null;

    for (let i = 0; i < lines.length; i++) {
      const pt = lines[i];
      // Normalize point
      let pos = pt.pos || pt;
      let isStb = (pt.isStb !== undefined) ? pt.isStb : true;
      const isGray = hasSelection && (i < selectionRange.min || i > selectionRange.max);

      if (currentSegment.length === 0) {
        currentSegment.push(pos);
        currentSegmentIsStb = isStb;
        currentSegmentIsGray = isGray;
        continue;
      }

      // S/P切り替え or グレー/カラー切り替えでセグメント区切り
      if (isStb !== currentSegmentIsStb || isGray !== currentSegmentIsGray) {
        currentSegment.push(pos);

        const segColor = currentSegmentIsGray ? '#999' : (currentSegmentIsStb ? '#28a745' : '#dc3545');
        const segOpacity = currentSegmentIsGray ? 0.3 : 0.8;
        const segWeight = currentSegmentIsGray ? 2 : 3;

        segments.push(
          <Polyline
            key={i}
            positions={currentSegment}
            color={segColor}
            weight={segWeight}
            opacity={segOpacity}
          />
        );

        currentSegment = [pos];
        currentSegmentIsStb = isStb;
        currentSegmentIsGray = isGray;
      } else {
        currentSegment.push(pos);
      }
    }

    if (currentSegment.length > 1) {
      const segColor = currentSegmentIsGray ? '#999' : (currentSegmentIsStb ? '#28a745' : '#dc3545');
      const segOpacity = currentSegmentIsGray ? 0.3 : 0.8;
      const segWeight = currentSegmentIsGray ? 2 : 3;
      segments.push(
        <Polyline
          key={'last'}
          positions={currentSegment}
          color={segColor}
          weight={segWeight}
          opacity={segOpacity}
        />
      );
    }
    return segments;
  }
}

function renderDistanceMarkers(lines, unit, interval = 200, display = true) {
  if (!lines || lines.length === 0) return null;
  if (display === false) return null;

  const markers = [];
  let accumulatedDist = 0;
  // Use interval from settings, default to 200 if undefined/null
  interval = interval || 200;
  let nextMarkDist = interval;

  const firstPt = lines[0];
  const firstPos = firstPt.pos || firstPt;

  if (!firstPos) return null;

  let prevLatLng = L.latLng(firstPos);

  for (let i = 1; i < lines.length; i++) {
    const pt = lines[i];
    const pos = pt.pos || pt;
    if (!pos) continue;

    const latLng = L.latLng(pos);
    const dist = prevLatLng.distanceTo(latLng);

    accumulatedDist += dist;

    if (accumulatedDist >= nextMarkDist) {
      const speedVal = (pt.speed !== undefined && pt.speed !== null) ? pt.speed.toFixed(1) : '-';

      markers.push(
        <CircleMarker
          key={'dist-' + i}
          center={latLng}
          radius={0}
          opacity={0}
          fillOpacity={0}
        >
          <Tooltip permanent direction="center" className="no-background-tooltip">
            <div style={{
              fontSize: '10px',
              color: 'black',
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              textShadow: '1px 1px 0px white'
            }}>
              {speedVal}
            </div>
          </Tooltip>
        </CircleMarker>
      );

      while (accumulatedDist >= nextMarkDist) {
        nextMarkDist += interval;
      }
    }

    prevLatLng = latLng;
  }

  return markers;
}
